import { GridColDef } from '@mui/x-data-grid-pro';

import { numberFormatter } from 'portal/src/utils/numberFormatter';

import { SERVICE_TYPES } from './AddFacilityForm';

export const getColumns = (): GridColDef[] => {
  return [
    {
      field: 'serviceType',
      headerName: 'Service Type',
      flex: 1,
      editable: true,
      type: 'singleSelect',
      valueOptions: SERVICE_TYPES,
    },
    {
      field: 'cost',
      headerName: 'Costs',
      flex: 1,
      editable: true,
      type: 'number',
      valueFormatter: (value) => numberFormatter(Number(value)),
    },
  ];
};
